import { render, staticRenderFns } from "./CostingLine.vue?vue&type=template&id=02372289&scoped=true&"
import script from "./CostingLine.vue?vue&type=script&lang=js&"
export * from "./CostingLine.vue?vue&type=script&lang=js&"
import style0 from "./CostingLine.vue?vue&type=style&index=0&id=02372289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02372289",
  null
  
)

export default component.exports